export default __webpack_public_path__ + "static/media/banner1.d28e3335.jpg";